import { withFormik } from "formik";
import { Link } from "react-router-dom";
import * as yup from "yup";
import { AuthShell } from "../register/auth-shell";
import "../register/auth-ui.css";
import { OrButton } from "../shared_modules/ui/components/atoms/or-button/or-button";
import { OrInput } from "../shared_modules/ui/components/atoms/or-input/or-input";
import { showOrToast } from "../shared_modules/ui/components/atoms/or-toast/or-toast";
import { useUserRepository } from "../user/useUserRepository";
import { useSocialMode } from "../social-auth/social-mode-context";
import { SocialRetrieve } from "../social-auth/social-retrieve";

export default function Retrieve() {
  const { recoverPassword } = useUserRepository();
  const { isSocialMode } = useSocialMode();

  if (isSocialMode) {
    return <SocialRetrieve />;
  }

  const FormView = (props) => {
    const { values, touched, errors, isSubmitting, handleChange, handleSubmit } = props;

    return (
      <form className="or-auth-form" onSubmit={handleSubmit}>
        <div className="or-auth-form__group">
          <OrInput
            id="email"
            inputType="email"
            label="Email *"
            name="email"
            onChange={handleChange}
            value={values.email}
            hasError={touched.email && Boolean(errors.email)}
            errorText={touched.email ? errors.email : ""}
          />
        </div>

        <div className="or-auth-form__group">
          <OrButton id="submit" type="submit" fullWidth isLoading={isSubmitting} size="lg" variant="primary">
            Restablecer la contraseña
          </OrButton>
        </div>
      </form>
    );
  };

  const validationsForm = {
    email: yup.string().email("Escribe un email válido").required("El email es requerido"),
  };

  const Form = withFormik({
    mapPropsToValues: ({ email }) => {
      return {
        email: email || "",
      };
    },

    enableReinitialize: true,
    validationSchema: yup.object().shape(validationsForm),
    handleSubmit: async (values) => {
      let result = await recoverPassword({
        email: values.email,
      });

      if (result) {
        showOrToast("Te hemos enviado un correo, comprueba la bandeja de entrada");
      }
    },
  })(FormView);

  return (
    <AuthShell
      title="¿Has olvidado tu contraseña?"
      subtitle="Restablecer la contraseña en dos pasos rápidos"
      footer={
        <>
          <p className="or-auth-form__hint">
            ¿Ya estás registrado? <Link to="/login">Inicia sesión</Link>
          </p>
          <a href="https://openreferences.com/aviso-legal/" target="_blank" rel="noreferrer">
            Términos y Condiciones
          </a>
        </>
      }
    >
      <Form />
    </AuthShell>
  );
}
